<script setup lang="ts">
import { computed } from 'vue'

import type { CampaignListItemType } from '@/lib/types/campaigns.types'
import { FlexComponent, TooltipComponent, TypographyComponent } from '@/ui-library'

const props = defineProps<{ targets: CampaignListItemType['targets'] }>()
const targetsList = [
  { key: 'storeGroups', label: 'advertiser group', tooltip: 'Advertiser Group IDs' },
  { key: 'users', label: 'creator', tooltip: 'Creator IDs' },
  { key: 'userTags', label: 'tag', tooltip: 'Tags IDs' },
  { key: 'clients', label: 'client', tooltip: 'Client IDs' },
  { key: 'revenueTiers', label: 'revenue tier', tooltip: 'Revenue Tiers' },
  { key: 'emails', label: 'email', tooltip: 'Emails' },
  { key: 'socialMediaIdentifiers', label: 'social media identifier', tooltip: 'Social Media Identifiers' },
]
const list = computed(() => {
  return targetsList.reduce((acc: { key: string; label: string; tooltip: string }[], target) => {
    const targetIds = props.targets?.[target.key as keyof typeof props.targets]
    if (targetIds?.length) {
      acc.push({
        key: target.key,
        label: `${targetIds.length} ${target.label}${targetIds.length > 1 ? 's' : ''}`,
        tooltip: `${target.tooltip}: ${targetIds.join(', ')}`,
      })
    }
    return acc
  }, [])
})
</script>
<template>
  <FlexComponent justify="center" wrap="wrap" class="campaign-targets-row">
    <TooltipComponent v-for="item in list" :key="item.key">
      <TypographyComponent variant="title-large">
        {{ item.label }}
      </TypographyComponent>
      <template #content>
        <TypographyComponent variant="body-small">{{ item.tooltip }}</TypographyComponent>
      </template>
    </TooltipComponent>
  </FlexComponent>
</template>
<style lang="scss" scoped>
.campaign-targets-row > * {
  display: flex;
  &:not(:last-child)::after {
    content: ', ';
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
  }
}
</style>
